import { BePlannedMonthly } from "./BePlannedMonthly";

export default BePlannedMonthly;
